import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { WorkerDeleteDto } from '../../_dto/_worker/WorkerDeleteDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiDelete = async (workerDeleteDto: WorkerDeleteDto) => {
  const params: IApiParams = {
    url: '/worker/delete.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', workerDeleteDto);
};
